import { CheckCircle2 } from "lucide-react";

import { useLanguage } from "../../context/LanguageContext";
export function WhySellSection({ header, benefits, btntext, btnlink }) {
  const { language, translate } = useLanguage();

  // Helper: Clean HTML — remove tags, strip inline styles, normalize text
  const cleanText = (raw = "") => {
    if (!raw) return "";

    // Step 1: Remove all HTML tags (including <p>, <span>, etc.)
    let cleaned = raw.replace(/<[^>]+>/g, " ");

    // Step 2: Remove any leftover style attributes or weird artifacts
    cleaned = cleaned.replace(/style="[^"]*"/g, "");

    // Step 3: Normalize multiple spaces/newlines
    cleaned = cleaned.replace(/\s+/g, " ").trim();

    return cleaned;
  };

  // Clean header
  const title =
    cleanText(header?.title?.value) || "Why Sell with Sky Auto Trade?";
  const subtitle = cleanText(header?.description?.value) || "";

  // Clean benefits
  const cleanedBenefits = (benefits || [])
    .map((benefit) => {
      // Better handling for title/description
      const rawTitle = benefit?.title?.value;
      const rawDescription = benefit?.description?.value;

      return {
        title: cleanText(rawTitle),
        description: cleanText(rawDescription),
        icon: benefit?.icon?.value?.trim() || "", // keep image URL
        // Keep raw values as fallback for debugging
        rawTitle,
        rawDescription,
      };
    })
    .filter((b) => {
      // Keep benefits that have either title OR description (after cleaning)
      // This prevents filtering out items when both are initially empty
      const hasTitle = b.title && b.title.trim().length > 0;
      const hasDescription = b.description && b.description.trim().length > 0;
      return hasTitle || hasDescription;
    });

  // Button Data from Header API
  const buttonText =
    header?.btntext?.value ||
    translate("newSeller.hero.startSelling") ||
    "SELL WITH CONFIDENCE";
  const ctaLink = header?.btnLink?.value || btnlink || "#";

  // Debug logging
  console.log("WhySellSection - header:", header);
  console.log("WhySellSection - benefits (raw):", benefits);
  console.log(
    "WhySellSection - cleanedBenefits after filter:",
    cleanedBenefits,
  );
  console.log(
    "WhySellSection - cleanedBenefits length:",
    cleanedBenefits.length,
  );
  console.log("WhySellSection - btntext prop:", btntext);

  // ✅ ADD THIS
  if (!cleanedBenefits || cleanedBenefits.length === 0) {
    console.warn("WhySellSection: No valid benefits found");
    console.warn("Raw benefits data:", benefits);
    console.warn(
      "Language detected:",
      "Check if API is returning data for current language",
    );
    return null;
  }

  return (
    // <section className="bg-bg-blue py-8 sm:py-12 lg:py-20">
    //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    //     <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-start">

    //       {/* Left Column – Title, Subtitle, Bullet List */}
    //       <div className="pt-4">
    //         <h2 className="text-4xl sm:text-5xl font-black text-white mb-8 tracking-tight leading-[1.1]">
    //           {title}
    //           <br />
    //           <span className="text-[#3b82f6]">{ 'Sky Auto Trade?' }</span>
    //         </h2>

    //         {/* Clean subtitle – no tags, no background color */}
    //         {subtitle && (
    //           <p className="text-gray-500 text-base sm:text-lg font-medium leading-relaxed mb-10 max-w-lg">
    //             {subtitle}
    //           </p>
    //         )}

    //         {/* Bullet List – same blue checkmarks */}
    //         <div className="space-y-5">
    //           {cleanedBenefits.map((benefit, idx) => (
    //             <div key={idx} className="flex items-center gap-4">
    //               <CheckCircle2 className="w-6 h-6 text-[#3b82f6]" strokeWidth={2.5} />
    //               <p className="text-white text-base sm:text-lg font-bold tracking-tight">
    //                 {benefit.title}
    //               </p>
    //             </div>
    //           ))}
    //         </div>

    //       </div>

    //       {/* Right Column – Benefit Cards */}
    //       <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
    //         {cleanedBenefits.map((benefit, idx) => {
    //           const hasIcon = benefit.icon

    //           return (
    //             <div
    //               key={idx}
    //               className="bg-[#13191f]/50 border border-white/5 rounded-[24px] p-8 lg:p-10 transition-all duration-300 hover:border-[#3b82f6]/30 hover:bg-[#161d26]"
    //             >
    //               {/* Icon Container */}
    //               <div className="w-12 h-12 bg-[#1d63a3]/10 rounded-xl flex items-center justify-center mb-8 border border-[#1d63a3]/20 overflow-hidden">
    //                 {hasIcon ? (
    //                   <img
    //                     src={benefit.icon}
    //                     alt={benefit.title}
    //                     className="w-6 h-6 object-contain"
    //                     onError={(e) => (e.currentTarget.style.display = 'none')}
    //                   />
    //                 ) : (
    //                   <CheckCircle2 className="w-6 h-6 text-[#3b82f6]" strokeWidth={1.5} />
    //                 )}
    //               </div>

    //               {/* Title */}
    //               {benefit.title && (
    //                 <h3 className="text-white font-black text-xl mb-4 tracking-tight">
    //                   {benefit.title}
    //                 </h3>
    //               )}

    //               {/* Description – clean text only, no tags or background */}
    //               {benefit.description && (
    //                 <p className="text-gray-500 text-sm leading-relaxed font-medium">
    //                   {benefit.description}
    //                 </p>
    //               )}
    //             </div>
    //           )
    //         })}
    //       </div>
    //     </div>
    //   </div>
    // </section>
    cleanedBenefits.length > 0 && (
      <section className="bg-page py-8 sm:py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-start">
            {/* Left Column – Title, Subtitle, Bullet List, and CTA Button */}
            <div className="pt-4">
              <h2 className="text-4xl sm:text-5xl font-black text-white mb-8 tracking-tight leading-[1.1]">
                {title.replace("Sky Auto Trade?", "")}
                <br />
                <span className="text-primary">Sky Auto Trade?</span>
              </h2>

              {subtitle && (
                <p className="text-gray-400 text-base sm:text-lg font-medium leading-relaxed mb-10 max-w-lg">
                  {subtitle}
                </p>
              )}

              {/* Bullet List */}
              {/* <div className="space-y-5 mb-10">
              {cleanedBenefits.map((benefit, idx) => (
                <div key={idx} className="flex items-center gap-4">
                  <CheckCircle2 className="w-6 h-6 text-[#3b82f6]" strokeWidth={2.5} />
                  <p className="text-white text-base sm:text-lg font-bold tracking-tight">
                    {benefit.title}
                  </p>
                </div>
              ))}
            </div> */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
                {cleanedBenefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-center gap-4">
                    <CheckCircle2
                      className="w-6 h-6 text-primary"
                      strokeWidth={2.5}
                    />
                    <p className="text-white text-base sm:text-lg font-bold tracking-tight">
                      {benefit.title}
                    </p>
                  </div>
                ))}
              </div>

              {/* Added CTA Button */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  className="bg-primary hover:bg-primary-dark text-white px-6 sm:px-8 py-4 rounded font-semibold flex items-center justify-center gap-2 text-sm sm:text-base transition-all duration-300 shadow-lg shadow-blue-600/20"
                  onClick={() =>
                    ctaLink !== "#" && (window.location.href = ctaLink)
                  }
                >
                  {btntext}
                  <span className="text-xl">→</span>
                </button>
              </div>
            </div>

            {/* Right Column – Benefit Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {cleanedBenefits.map((benefit, idx) => {
                const hasIcon = benefit.icon;

                return (
                  <div
                    key={idx}
                    className="bg-[#13191f]/50 border border-white/5 rounded-[24px] p-8 lg:p-10 transition-all duration-300 hover:border-primary/30 hover:bg-[#161d26] group"
                  >
                    {/* Icon Container */}
                    <div className="w-12 h-12 bg-[#1d63a3]/10 rounded-xl flex items-center justify-center mb-8 border border-[#1d63a3]/20 overflow-hidden group-hover:border-[#3b82f6]/50 transition-colors">
                      {hasIcon ? (
                        <img
                          src={benefit.icon}
                          alt={benefit.title}
                          className="w-6 h-6 object-contain"
                          onError={(e) =>
                            (e.currentTarget.style.display = "none")
                          }
                        />
                      ) : (
                        <CheckCircle2
                          className="w-6 h-6 text-primary"
                          strokeWidth={1.5}
                        />
                      )}
                    </div>

                    {/* Title */}
                    {benefit.title && (
                      <h3 className="text-white font-black text-xl mb-4 tracking-tight">
                        {benefit.title}
                      </h3>
                    )}

                    {/* Description */}
                    {benefit.description && (
                      <p className="text-gray-500 text-sm leading-relaxed font-medium">
                        {benefit.description}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    )
  );
}
